var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',_vm._l((_vm.tabs),function(tab){return _c('router-link',{key:tab.id,staticClass:"item",attrs:{"to":tab.pathTo,"active-class":"selected"}},[_c('Icon',{attrs:{"name":tab.iconName}}),_vm._v(" "+_vm._s(tab.title)+" ")],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }